import { CHECKLIST_ITEMS, type ChecklistItem } from '@qm/contracts/partners';
import type { ApplicationView } from './index';
interface WireChecklistItem {
  item: string;
  checked: boolean;
  checkedBy?: string | null;
  checkedAt?: string | null;
  note?: string | null;
}
export type ApplicationWire = Omit<ApplicationView, 'checklist'> & {
  checklistReadyAt?: string | null;
  checklist?: ApplicationView['checklist'] | { items: WireChecklistItem[]; complete: boolean };
};
/** Align the actual server response with the staff screen; never infer readiness from absent checks. */
export function normalizeApplication(raw: ApplicationWire): ApplicationView {
  const { checklist, checklistReadyAt, ...rest } = raw;
  let normalized: ApplicationView['checklist'];
  if (checklist && 'items' in checklist && Array.isArray(checklist.items)) {
    normalized = {};
    for (const item of checklist.items) {
      if (!(CHECKLIST_ITEMS as readonly string[]).includes(item.item)) continue;
      normalized[item.item as ChecklistItem] = {
        checked: item.checked === true,
        by: item.checkedBy ?? null,
        at: item.checkedAt ?? null,
        note: item.note ?? null,
      };
    }
  } else normalized = checklist as ApplicationView['checklist'];
  return { ...rest, readyAt: rest.readyAt ?? checklistReadyAt ?? null, checklist: normalized };
}
